import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { country_code_array } from './functions';
import { domestic_destination_array } from './functions';
import { get_phone_code } from './functions';
import '../../Order.css'
import axios from 'axios';
import { Helmet } from 'react-helmet';
import BACKEND_URL from '../../api';
import OrderFunctionStore from '../../store/OrderFunctionStore';
import countryCodeMap from '../../countryCodes.json';

const libraries = ['places'];
const mapContainerStyle = {
    width: '100%',
    height: '400px',
};

export default function Order_detail({ inputs, number, totalNumber, collectionDetails, setcollectionDetails,
    deliveryDetails, setdeliveryDetails, parcel_info, setparcel_info, setParcelDetailOptionError, parcelDetailOptionError, setFiles }) {

    const [center1, setCenter1] = useState({ lat: 37.422, lng: -122.084 });
    const [center2, setCenter2] = useState({ lat: 37.422, lng: -122.084 });
    const { parcelDetailOption, setParcelDetailOption, parcelDetailFirstOption, setParcelDetailFirstOption, setParcelDetailSecondOption } = OrderFunctionStore();

    useEffect(() => {
        if (parcelDetailFirstOption == true) {
            setnextpage(1)
            let error = 0; let error2 = 0; let erroremail = 0; let erroremail2 = 0; let errorinsurance = 0;
            if (collectionDetails.name == "" || collectionDetails.phone == "" || collectionDetails.email == "" || collectionDetails.address == "" || collectionDetails.city == "") {
                // alert('Please enter the required fields')
                seterrormsg('Please enter the required fields')
                setcollectionstate(true)
                error = 1
            } else {
                seterrormsg()
                error = 0;
                let lastAtPos = collectionDetails.email.lastIndexOf("@");
                let lastDotPos = collectionDetails.email.lastIndexOf(".");

                if (
                    !(
                        lastAtPos < lastDotPos &&
                        lastAtPos > 0 &&
                        collectionDetails.email.indexOf("@@") == -1 &&
                        lastDotPos > 2 &&
                        collectionDetails.email.length - lastDotPos > 2
                    )
                ) {

                    erroremail = 1
                    setemailerrormsg('Please enter a valid collection email id')
                } else {
                    error = 0;
                    erroremail = 0;
                    setemailerrormsg()
                }
            }
            if (deliveryDetails.name == "" || deliveryDetails.phone == "" || deliveryDetails.address == "" || deliveryDetails.city == "") {
                seterrormsg('Please enter the required fields')
                setdeliverystate(true)
                error2 = 1
            } else {
                seterrormsg()
                seterrormsg()
                let lastAtPos = deliveryDetails.email.lastIndexOf("@");
                let lastDotPos = deliveryDetails.email.lastIndexOf(".");

                if (
                    !(
                        lastAtPos < lastDotPos &&
                        lastAtPos > 0 &&
                        deliveryDetails.email.indexOf("@@") == -1 &&
                        lastDotPos > 2 &&
                        deliveryDetails.email.length - lastDotPos > 2
                    )
                ) {

                    //erroremail2 = 1
                    // setemailerrormsg2('Please enter a valid delivery email id')
                } else {
                    error2 = 0;
                    erroremail2 = 0;
                    setemailerrormsg2()
                }
            }
            if (parcel_info.parceldetails.insurance.length > parcel_info.parceldetails.parcel_value.length) {
                if (parcel_info.parceldetails.insurance[0] == 'Yes') {
                    setinsuranceerrormsg('Please enter parcel value')
                    errorinsurance = 1
                }

            } else {
                setinsuranceerrormsg('')
                errorinsurance = 0
            }

            if ((error == 0) && (error2 == 0) && (erroremail == 0) && (erroremail2 == 0) && (errorinsurance == 0)) {

                setParcelDetailOptionError(false); // Set the new state

                setParcelDetailSecondOption(true);
                setordersummary('active')
                setparceldetails('')
            }
        }
    }, [parcelDetailOption])

    let userid = sessionStorage.getItem('userid')
    const [countries, setcountries] = useState(country_code_array);
    const [domesticloc, setdomesticloc] = useState(domestic_destination_array);
    const [countryphone, setcountryphone] = useState(get_phone_code);

    const [collectionMap, setCollectionMap] = useState(false);
    const [deliveryMap, setDeliveryMap] = useState(false);
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyCLFuQW4ZE_EHv4d90HJvj4tGwgEodiEXE',
        libraries
    });

    const [destination, setdestination] = useState(inputs['destination'])
    const [origin, setorigin] = useState(inputs['origin'])

    sessionStorage.setItem('display_currency', 'AED');
    const [uploadstats, setuploadstats] = useState(1)
    const stateRef = useRef();
    stateRef.current = uploadstats;

    useEffect(() => {
        setcollectionDetails({
            name: '',
            email: '',
            phonecode: countryphone[origin],
            phone: '',
            address: '',
            city: '',
            country: inputs['origin'],
            zip_code: ''
        })

        setdeliveryDetails({
            name: '',
            email: '',
            phonecode: countryphone[destination],
            phone: '',
            address: '',
            city: '',
            country: inputs['destination'],
            zip_code: ''
        })

        const insurances = [];
        for (let i = 0; i < inputs.dimensions.height.length; i++) {
            insurances.push("No"); // Use push to add items to the array
        }

        setparcel_info({
            parceldetails: {
                description: [''],
                parcel_value: [''],
                promocode: [''],
                insurance: insurances, // Set the insurance array here
                comments: [''],
                image: ['']
            }
        });
    }, [])

    useEffect(() => {
        const fetchCoordinates = async () => {
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(collectionDetails.address)}&key=AIzaSyCLFuQW4ZE_EHv4d90HJvj4tGwgEodiEXE`);
            const data = await response.json();

            if (data.results && data.results.length > 0) {
                const { lat, lng } = data.results[0].geometry.location;
                setCenter1({ lat, lng }); // Set the map center to the fetched coordinates
            }
        };
        fetchCoordinates();
    }, [collectionDetails.address]);

    useEffect(() => {
        const fetchCoordinates = async () => {
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(deliveryDetails.address)}&key=AIzaSyCLFuQW4ZE_EHv4d90HJvj4tGwgEodiEXE`);
            const data = await response.json();

            if (data.results && data.results.length > 0) {
                const { lat, lng } = data.results[0].geometry.location;
                setCenter2({ lat, lng }); // Set the map center to the fetched coordinates
            }
        };
        fetchCoordinates();
    }, [deliveryDetails.address]);

    const handleMapCollectionClick = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        // Call the Geocoding API to get the location name
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCLFuQW4ZE_EHv4d90HJvj4tGwgEodiEXE`);
        const data = await response.json();
        if (data.results && data.results.length > 0) {
            const addressComponents = data.results[0].address_components;
            let streetAddress = '';
            let city = '';
            let zipCode = '';
            // Loop through address components to find street address and city
            addressComponents.forEach(component => {
                if (component.types.includes('route') || component.types.includes('street_number')) {
                    streetAddress += `${component.long_name} `;
                }
                if (component.types.includes('locality') || component.types.includes('administrative_area_level_2')) {
                    city = component.long_name;
                }
                if (component.types.includes('postal_code')) {
                    zipCode = component.long_name;
                }
            });
            // Trim any extra spaces
            streetAddress = streetAddress.trim();
            const temp = { ...collectionDetails, address: streetAddress, city: city, zip_code: zipCode };
            setcollectionDetails(temp);
            setCenter1({ lat: lat, lng: lng });
        }
    };

    const handleMapDeliveryClick = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        // Call the Geocoding API to get the location name
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCLFuQW4ZE_EHv4d90HJvj4tGwgEodiEXE`);
        const data = await response.json();
        if (data.results && data.results.length > 0) {
            const addressComponents = data.results[0].address_components;
            let streetAddress = '';
            let city = '';
            let zipCode = '';
            // Loop through address components to find street address and city
            addressComponents.forEach(component => {
                if (component.types.includes('route') || component.types.includes('street_number')) {
                    streetAddress += `${component.long_name} `;
                }
                if (component.types.includes('locality') || component.types.includes('administrative_area_level_2')) {
                    city = component.long_name;
                }
                if (component.types.includes('postal_code')) {
                    zipCode = component.long_name;
                }
            });
            // Trim any extra spaces
            streetAddress = streetAddress.trim();
            const temp = { ...deliveryDetails, address: streetAddress, city: city, zip_code: zipCode };
            setdeliveryDetails(temp);
            setCenter2({ lat: lat, lng: lng });
        }
    };

    const [disable, setdisable] = useState(false)
    useEffect(() => {
        if (inputs['origin'] == 'DXB' || inputs['origin'] == 'AUH' || inputs['origin'] == 'SHJ') {
            setdestination('AE')
            setorigin('AE')
            setdisable(true)
            setcollectionDetails({ ...collectionDetails, city: domesticloc[inputs['origin']], phonecode: '+971' })
            setdeliveryDetails({ ...deliveryDetails, city: domesticloc[inputs['destination']], phonecode: '+971' })
        }
    }, [])

    const dimensions = inputs['dimensions']
    const shipmenttype = inputs['shipmenttype']
    const itemcount = dimensions['weight'].length;
    const [countdiv, setcountdiv] = useState(itemcount)
    const [collectionstate, setcollectionstate] = useState(false)
    const [deliverystate, setdeliverystate] = useState(false)

    function changeState() {
        if (collectionstate == false) {
            setcollectionstate(true)
        } else {
            setcollectionstate(false)
        }
    }

    function changeStatedelivery() {
        if (deliverystate == false) {
            setdeliverystate(true)
        } else {
            setdeliverystate(false)
        }
    }

    function updateparcelinfodesc(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.description]
        updatedAccepted[i] = val;
        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                description: updatedAccepted
            }
        });
    }

    function updateparcelinfovalue(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.parcel_value]
        updatedAccepted[i] = val;
        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                parcel_value: updatedAccepted
            }
        });
    }

    function updateparcelinfoinsurance(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.insurance]
        updatedAccepted[i] = val;
        // console.log(parcel_info.parceldetails.parcel_value)
        // if(val=='yes' && parcel_info.parceldetails.parcel_value[i]==[] ){
        //   seterrormsgvalue('Please enter parcel value')
        // }

        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                insurance: updatedAccepted
            }
        });
    }

    function updateparcelinfocomments(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.comments]
        updatedAccepted[i] = val;
        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                comments: updatedAccepted
            }
        });
    }
    function updateparcelinfopromocode(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.promocode]
        updatedAccepted[i] = val;
        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                promocode: updatedAccepted
            }
        });
    }

    function updateparcelimage(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...parcel_info.parceldetails };
        const updatedAccepted = [...clonedListing.image]
        updatedAccepted[i] = val;

        setFiles(val)
        setparcel_info({
            ...parcel_info,
            parceldetails: {
                ...clonedListing,
                image: updatedAccepted
            }
        });
    }

    const [parceldetails, setparceldetails] = useState('active')
    const [ordersummary, setordersummary] = useState()
    const [finalprice, setfinalprice] = useState()
    const [errormsg, seterrormsg] = useState()
    const [insuranceerrormsg, setinsuranceerrormsg] = useState()
    const [emailerrormsg, setemailerrormsg] = useState()
    const [emailerrormsg2, setemailerrormsg2] = useState()
    const [nextpage, setnextpage] = useState(0)

    const [getQuotedata, setgetQuotedata] = useState(
        inputs
    )

    function updateweight(val, i) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.weight]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                weight: updatedAccepted
            }
        });

    }

    function updatelength(val, i) {
        const updatedCount = 1;
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.length]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                length: updatedAccepted
            }
        });

    }

    function updatewidth(val, i) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.width]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                width: updatedAccepted
            }
        });

    }

    function updateheight(val, i) {
        const clonedListing = { ...getQuotedata.dimensions };
        const updatedAccepted = [...clonedListing.height]
        updatedAccepted[i] = val;
        setgetQuotedata({
            ...getQuotedata,
            dimensions: {
                ...clonedListing,
                height: updatedAccepted
            }
        });

    }

    const [collectionaddress, setcollectionaddress] = useState()
    const [collectioncount, setcollectioncount] = useState()
    const [deliveryaddress, setdeliveryaddress] = useState()
    const [deliverycount, setdeliverycount] = useState()
    useEffect(() => {
        if (userid && userid > 0) {
            axios({
                method: "post",
                url: `${BACKEND_URL}/getAddressOrder`,
                data: { userid: userid, origin: inputs['origin'], destination: inputs['destination'] }
            })
                .then((res) => {
                    console.log("getAddressOrder-------", res.data)
                    setcollectionaddress(res.data.collection)
                    setcollectioncount(res.data.collection.length)
                    setdeliveryaddress(res.data.delivery)
                    setdeliverycount(res.data.delivery.length)
                })
                .catch((err) => console.log(err))
        }
    }, [])

    function getAddress(val) {
        setcollectionDetails({
            ...collectionDetails,
            name: collectionaddress[val]['name']
            , email: collectionaddress[val]['email'],
            phone: collectionaddress[val]['phone'],
            address: collectionaddress[val]['address'],
            city: collectionaddress[val]['city'],
            zip_code: collectionaddress[val]['zipcode']
        })
    }

    function getAddressdelivery(val) {
        setdeliveryDetails({
            ...deliveryDetails,
            name: deliveryaddress[val]['name']
            , email: deliveryaddress[val]['email'],
            phone: deliveryaddress[val]['phone'],
            address: deliveryaddress[val]['address'],
            city: deliveryaddress[val]['city'],
            zip_code: deliveryaddress[val]['zipcode']
        })
    }

    const [addmsg, setaddmsg] = useState()
    function savecollection() {
        axios({
            method: 'post',
            url: `${BACKEND_URL}/saveAddress`,
            data: { user: userid, collectionDetails: collectionDetails, type: 'collection' }
        })
            .then((res) => {
                console.log("saveAddress-------:", res.data)
                setaddmsg('Address saved')
            })
            .catch(err => console.log(err))
    }
    const [deliveryaddmsg, setdeliveryaddmsg] = useState()
    function savedelivery() {
        axios({
            method: 'post',
            url: `${BACKEND_URL}/saveAddress`,
            data: { user: userid, collectionDetails: deliveryDetails, type: 'delivery' }
        })
            .then((res) => {
                console.log("saveAddress-------:", res.data)
                setdeliveryaddmsg('Address saved')
            })
            .catch(err => console.log(err))
    }

    const [suggestions, setsuggestions] = useState();
    const [showsuggestion, setshowsuggestion] = useState(false)
    const [showsuggestiondelivery, setshowsuggestiondelivery] = useState(false)
    const [placeids, setplaceids] = useState();
    const [placeidsdelivery, setplaceidsdelivery] = useState();
    function checkSuggestions(val) {
        if (shipmenttype == 'domestic') {
            setcollectionDetails({ ...collectionDetails, address: val })
        } else {
            setcollectionDetails({ ...collectionDetails, address: val })

            if (val.length > 3) {
                axios({
                    method: 'post',
                    url: `${BACKEND_URL}/placeapi`,
                    data: { place: val, country: origin }
                }).then((res) => {
                    console.log("placeAPI--------->", res.data)
                    if (res.data.status == 1) {
                        setshowsuggestion(true)
                        setsuggestions(res.data.suggestions)
                        setplaceids(res.data.placeids)
                    }
                })
                    .catch(err => console.log(err))
            } else {
                setcollectionDetails({ ...collectionDetails, address: val })
            }
        }
    }

    function setSuggestaddress(k) {
        setcollectionDetails({ ...collectionDetails, address: k })
        axios({
            method: 'post',
            url: `${BACKEND_URL}/cityApi`,
            data: { placeid: placeids[k] }
        }).then((res) => {
            console.log("cityAPI--------->", res.data)
            if (res.data.status == 1) {
                setcollectionDetails({ ...collectionDetails, address: k, city: res.data.cityname, zip_code: res.data.zipcode })
            }
        })
            .catch(err => console.log(err))
    }

    function checkSuggestionsdelivery(val) {
        if (shipmenttype == 'domestic') {
            setdeliveryDetails({ ...deliveryDetails, address: val })
        } else {
            setdeliveryDetails({ ...deliveryDetails, address: val })
            if (val.length > 3) {
                axios({
                    method: 'post',
                    url: `${BACKEND_URL}/placeapi`,
                    data: { place: val, country: destination }
                }).then((res) => {
                    if (res.data.status == 1) {

                        setshowsuggestiondelivery(true)
                        setsuggestions(res.data.suggestions)
                        setplaceidsdelivery(res.data.placeids)
                    }
                })
                    .catch(err => console.log(err))
            } else {
                setdeliveryDetails({ ...deliveryDetails, address: val })
            }
        }
    }

    function setSuggestaddressdelivery(k) {
        setdeliveryDetails({ ...deliveryDetails, address: k })
        axios({
            method: 'post',
            url: `${BACKEND_URL}/cityApi`,
            data: { placeid: placeidsdelivery[k] }
        }).then((res) => {

            if (res.data.status == 1) {

                setdeliveryDetails({ ...deliveryDetails, address: k, city: res.data.cityname, zip_code: res.data.zipcode })
            }
        })
            .catch(err => console.log(err))
    }

    function removesuggest() {
        setTimeout(() => setshowsuggestion(false), 300)
    }

    function removesuggestdelivery() {
        setTimeout(() => setshowsuggestiondelivery(false), 300)
    }

    return (
        <div className="order">
            <Helmet>
                <title>Shypv | Order Detail</title>
            </Helmet>

            {
                number === 0 && <div className="stepwise-row">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 col-sm-4 col-xs-12 text-center no-pad"><a href="" className={`${parceldetails}`} onClick={() => setParcelDetailSecondOption(false)}><i className="fa fa-pencil" />Parcel Details</a></div>
                            <div className="col-md-4 col-sm-4 col-xs-12 text-center no-pad"><a href="" className={`${ordersummary}`}><i className="fa fa-check" /> Order Summary</a></div>
                            <div className="col-md-4 col-sm-4 col-xs-12 text-center no-pad"><a href="" className=""><i className="fa fa-credit-card" />Submit Order</a></div>
                        </div>
                    </div>
                </div>
            }

            <div className="parsel_container pages_content1" style={(number !== 0) ? { paddingTop: "0px" } : {}}>
                <div className="container" style={(number == 0) ? { marginTop: "10px" } : { marginTop: "0px" }}>
                    {
                        (userid && number == 0) ? (
                            <Link className="orderBackButton" to="/home">Home</Link>
                        ) : null
                    }
                    <div className="row" style={(number == 0) ? { marginTop: "1%" } : { marginTop: "0px" }}>
                        <div className="col-md-12 col-sm-12 col-xs-12 become_driver order-cont order-cont order-cnt-pldl">
                            {parcelDetailOptionError.includes(true) && (
                                <form method="post" id="parcel_details" name="parcel_details" encType="multipart/form-data">
                                    <div className="add_more_parcels">
                                        <h3 className="sectiontitle">- My Parcel Details To {countries[`${destination}`]}</h3>
                                        {[...Array(countdiv)].map((e, i) => <>
                                            <div className="gray_box box_new" id="">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label for="exampleInputEmail1">Parcel {number + 1} Description </label>
                                                            <input type="text" className="form-control parcel_content" onChange={(e) => updateparcelinfodesc(e.target.value, i)} name="parcel_content[]" id="parcel_content" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Value</label>
                                                            <div className="input-group new-group">
                                                                <div className="input-group-addon">AED</div>
                                                                <input type="text" className="form-control my_parcel_detail insure_empty" onChange={(e) => updateparcelinfovalue(e.target.value, i)} id="" name="parcel_cost[]" defaultValue="" />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {i == 0 ? (<>
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">Upload invoice</label>
                                                                <input type="file" className="form-control my_parcel_detail" multiple onChange={(e) => updateparcelimage(e.target.files[0], i)} id="" name="fileToUpload[]" />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2" style={{}}>
                                                            <div className="form-group">
                                                                <label htmlFor="exampleInputEmail1">Promocode</label>
                                                                <input type="text" className="form-control" defaultValue="" name="promo_code" id="promo_code" placeholder="Enter promocode" onChange={(e) => updateparcelinfopromocode(e.target.value, i)} />
                                                            </div>
                                                        </div>
                                                    </>
                                                    ) : null}

                                                </div>

                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Weight*</label>
                                                            <div className="input-group new-group">
                                                                <select className="form-control" name="weight[]" style={{ margin: 0 }} onChange={(e) => updateweight(e.target.value, i)} >
                                                                    {inputs.shipmenttype && inputs.typediv == 'package' ? (
                                                                        <>
                                                                            <option value="0.5" selected={dimensions['weight'][i] === '0.5'} >0.5</option>
                                                                            <option value="1" selected={dimensions['weight'][i] === '1'}>1</option>
                                                                            <option value="1.5" selected={dimensions['weight'][i] === '1.5'}>1.5</option>
                                                                            <option value="2" selected={dimensions['weight'][i] === '2'}>2</option>
                                                                            <option value="2.5" selected={dimensions['weight'][i] === '2.5'}>2.5</option>
                                                                            <option value="3" selected={dimensions['weight'][i] === '3'}>3</option>
                                                                            <option value="3.5" selected={dimensions['weight'][i] === '3.5'}>3.5</option>
                                                                            <option value="4" selected={dimensions['weight'][i] === '4'}>4</option>
                                                                            <option value="4.5" selected={dimensions['weight'][i] === '4.5'} >4.5</option>
                                                                            <option value="5" selected={dimensions['weight'][i] === '5'}>5</option>
                                                                            <option value="5.5" selected={dimensions['weight'][i] === '5.5'}>5.5</option>
                                                                            <option value="6" selected={dimensions['weight'][i] === '6'}>6</option>
                                                                            <option value="6.5" selected={dimensions['weight'][i] === '6.5'}>6.5</option>
                                                                            <option value="7" selected={dimensions['weight'][i] === '7'}>7</option>
                                                                            <option value="7.5" selected={dimensions['weight'][i] === '7.5'}>7.5</option>
                                                                            <option value="8" selected={dimensions['weight'][i] === '8'}>8</option>
                                                                            <option value="8.5" selected={dimensions['weight'][i] === '8.5'} >8.5</option>
                                                                            <option value="9" selected={dimensions['weight'][i] === '9'}>9</option>
                                                                            <option value="9.5" selected={dimensions['weight'][i] === '9.5'}>9.5</option>

                                                                            {[...Array(70)].map((x, k) => (
                                                                                k > 9 ? (
                                                                                    <option value={k} key={k} selected={dimensions['weight'][i] == k}>{k}</option>
                                                                                ) : null
                                                                            )
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <option value="0.5" selected={dimensions['weight'][i] === '0.5'}>0.5</option>
                                                                            <option value="1" selected={dimensions['weight'][i] === '1'}>1</option>
                                                                            <option value="1.5" selected={dimensions['weight'][i] === '1.5'}>1.5</option>
                                                                            <option value="2" selected={dimensions['weight'][i] === '2'}>2</option>
                                                                            <option value="2.5" selected={dimensions['weight'][i] === '2.5'}>2.5</option>
                                                                        </>
                                                                    )}
                                                                </select>
                                                                <div className="input-group-addon">Kg</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Length</label>
                                                            <div className="input-group new-group">
                                                                <input type="text" className="form-control my_parcel_detail" defaultValue={dimensions['length'][i]} name="length[]" onChange={(e) => updatelength(e.target.value, i)} />
                                                                <div className="input-group-addon">cm</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label>Width</label>
                                                            <div className="input-group new-group">
                                                                <input type="text" className="form-control my_parcel_detail" defaultValue={dimensions['width'][i]} name="width[]" onChange={(e) => updatewidth(e.target.value, i)} />
                                                                <div className="input-group-addon">cm</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label>Height</label>
                                                            <div className="input-group new-group">
                                                                <input type="text" className="form-control my_parcel_detail" defaultValue={dimensions['height'][i]} e="height[]" onChange={(e) => updateheight(e.target.value, i)} />
                                                                <div className="input-group-addon">cm</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {shipmenttype != 'domestic' ? (
                                                        <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Want to insure your shipment?</label>
                                                                <select className="form-control insure" id="insure<?php echo $i; ?>" data-id="<?php echo $i; ?>" name="insure[]" onChange={(e) => updateparcelinfoinsurance(e.target.value, i)}>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No" selected>No</option>
                                                                </select>
                                                                <label className="error_insurance<?php echo $i; ?>" style={{ color: 'red', display: 'none' }}>(Please complete parcel value)</label>
                                                                <label className="error_insurance1<?php echo $i; ?>" style={{ color: 'red', display: 'none' }} />
                                                            </div>
                                                        </div>
                                                    ) : null}

                                                    <div className="col-md-5">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleFormControlTextarea1">Additional Comments</label>
                                                            <textarea className="form-control" name="addcomment[]" rows="1" maxLength="400" defaultValue={""} onChange={(e) => updateparcelinfocomments(e.target.value, i)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        )}
                                    </div>

                                    {/* Collection Details */}

                                    <h3 className="sectiontitle toggle-btn-collection order-cont collection_details" style={{ width: '100%' }}>
                                        <a className id="countCollection" role="button" style={{ position: 'relative', color: '#4a4a4a', fontSize: "20px" }}>Collection Details&nbsp;
                                            {
                                                collectionstate == true ? (
                                                    <span style={{ border: "1px solid", padding: "4px", borderRadius: "5px" }} onClick={changeState}>-</span>
                                                ) : (
                                                    <span style={{ border: "1px solid", padding: "4px", borderRadius: "5px" }} onClick={changeState}>+</span>
                                                )
                                            }
                                            <div className="center-con" style={{ right: '-40px' }}>
                                                <div className="round">

                                                </div>
                                            </div>
                                        </a>
                                    </h3>
                                    {collectionstate == true ? (
                                        <div className="coll_de">
                                            <div className="gray_box box_new">
                                                {userid && userid > 0 ? (
                                                    <>
                                                        <div className="row" style={{}}>
                                                            <div className="col-md-12">
                                                                <div style={{ float: "right", top: '-30px' }}>
                                                                    <a onClick={savecollection} className="btn  tooltip-op" style={{ borderRadius: '20px', borderColor: '#3c50e0', background: "#3c50e0", color: "#fff" }} id="collection_details" data-id="collection_details">Save <span className="tooltiptext-op"></span> </a>
                                                                    <p>{addmsg}</p>
                                                                </div>
                                                                <div style={{ position: 'absolute', right: 0 }}> <label id="error_col_del" style={{ display: 'none' }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3" style={{ marginTop: "-6px" }}>
                                                                <select className="form-control" name="save_details_collection" onChange={(e) => getAddress(e.target.value)} id="details_collection">
                                                                    <option value>Select Save Address</option>

                                                                    {
                                                                        [...Array(collectioncount)].map((e, i) => <>
                                                                            {collectionaddress && collectionaddress[i] != '' ? (

                                                                                <option key={i} value={i}>{collectionaddress[i]['name']}-{collectionaddress[i]['address']}</option>
                                                                            ) : null
                                                                            }
                                                                        </>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className="col-md-2 adrresscheck">  <Link to="/my-account/address-book" style={{ padding: '10px', backgroundColor: '#3c50e0', color: '#fff', borderRadius: '4px', textDecoration: " none" }} className="addresslink">Check address book</Link>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : null
                                                }


                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Name<span className="required">*</span></label>
                                                            <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.name.length < 1 ? 'error form-control' : 'form-control'} value={collectionDetails.name} name="collection_name" onChange={(e) => setcollectionDetails({ ...collectionDetails, name: e.target.value })} id="collection_name" maxLength={50} placeholder="Name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Email<span className="required">*</span></label>
                                                            <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.email.length < 1 ? 'error form-control' : 'form-control'} value={collectionDetails.email} name="collection_email" onChange={(e) => setcollectionDetails({ ...collectionDetails, email: e.target.value })} id="collection_email" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Phone<span className="required">*</span></label>
                                                            <div className="input-group new-group">
                                                                {/* <div className="input-group-addon" style={{ paddingTop: "6%" }}>{countryphone[`${origin}`]}</div>
                                                                <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.phone.length < 1 ? 'error form-control' : 'form-control'} value={collectionDetails.phone} name="collection_phone" id="collection_phone" onChange={(e) => setcollectionDetails({ ...collectionDetails, phone: e.target.value })} placeholder="Phone" style={{ margin: 0 }} /> */}
                                                                <PhoneInput
                                                                    international
                                                                    countryCallingCodeEditable={false}
                                                                    defaultCountry={countryCodeMap[countries[`${origin}`]]}
                                                                    value={collectionDetails.phone}
                                                                    onChange={(newPhone) => setcollectionDetails({ ...collectionDetails, phone: newPhone })}
                                                                    style={{ "display": "flex", "backgroundColor": "#f7f7f7", "height": "2.9em" }}
                                                                    className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.phone.length < 1 ? 'error form-control' : 'form-control'}
                                                                />
                                                                <input type="hidden" name="collection_phone_code" id="collection_phone_code" defaultValue="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Address<span className="required">*</span></label>
                                                            <div className="input-group new-group">
                                                                <div className="input-group-addon" style={{ paddingTop: "6%", cursor: 'pointer' }} onClick={() => setCollectionMap(!collectionMap)}>Map</div>
                                                                <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.address.length < 1 ? 'error form-control' : 'form-control'} value={collectionDetails.address} name="collection_address" onChange={(e) => checkSuggestions(e.target.value)} id="collection_address" placeholder="Address" onBlur={removesuggest} />
                                                            </div>
                                                            {showsuggestion == true ? (<>
                                                                <div className="suggestions">
                                                                    {
                                                                        suggestions.map((k, i) => <>
                                                                            {i > 0 ? (
                                                                                <p key={i} className="suggest" value={k} onClick={() => setSuggestaddress(k)} onBlur={removesuggest}>{k}</p>
                                                                            ) : null}
                                                                        </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </>
                                                            ) : null}

                                                            {
                                                                collectionMap && <GoogleMap mapContainerStyle={mapContainerStyle} zoom={10} center={center1} onClick={handleMapCollectionClick}>
                                                                    <Marker position={center1} />
                                                                </GoogleMap>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-md-8">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">City/Town<span className="required">*</span></label>
                                                                    {disable ? (
                                                                        <input type="text" disabled className="form-control" value={collectionDetails.city} name="collection_city" onChange={(e) => setcollectionDetails({ ...collectionDetails, city: e.target.value })} id="collection_city" placeholder="City/Town" />
                                                                    ) : (
                                                                        <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && collectionDetails.city.length < 1 ? 'error form-control' : 'form-control'} value={collectionDetails.city} name="collection_city" onChange={(e) => setcollectionDetails({ ...collectionDetails, city: e.target.value })} id="collection_city" placeholder="City/Town" />
                                                                    )}

                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Country<span className="required">*</span></label>

                                                                    <input type="text" className="form-control" name="collection_country" id="collection_country" defaultValue={countries[`${origin}`]} disabled />


                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Zipcode</label>
                                                                    <input type="text" className="form-control cd" value={collectionDetails.zip_code} name="collection_zipcode" onChange={(e) => setcollectionDetails({ ...collectionDetails, zip_code: e.target.value })} id="collection_zipcode" placeholder="Zipcode" />
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>


                                                </div>

                                            </div>

                                        </div>
                                    ) : null}

                                    <hr className="hr_border" style={{ margin: '20px 0' }} />
                                    {/* Delivery Details */}

                                    <h3 className="sectiontitle toggle-btn-collection order-cont collection_details" style={{ width: '100%' }}>
                                        <a className id="countDelivery" role="button" style={{ position: 'relative', color: '#4a4a4a', fontSize: "20px" }}>Delivery Details&nbsp;
                                            {
                                                deliverystate == true ? (
                                                    <span style={{ border: "1px solid", padding: "4px", borderRadius: "5px" }} onClick={changeStatedelivery}>-</span>
                                                ) : (
                                                    <span style={{ border: "1px solid", padding: "4px", borderRadius: "5px" }} onClick={changeStatedelivery}>+</span>
                                                )
                                            }
                                            <div className="center-con" style={{ right: '-40px' }}>
                                                <div className="round">
                                                    <span />
                                                    <span />
                                                    <span />
                                                    <span />
                                                </div>
                                            </div>
                                        </a>
                                    </h3>
                                    {deliverystate == true ? (
                                        <div className="del_dd " id="collapseExample1">
                                            <div className="gray_box box_new">

                                                {userid && userid > 0 ? (
                                                    <>
                                                        <div className="row" style={{}}>
                                                            <div className="col-md-12">
                                                                <div style={{ float: "right", top: '-30px' }}>
                                                                    <a onClick={savedelivery} className="btn  tooltip-op" style={{ borderRadius: '20px', borderColor: '#3c50e0', background: "#3c50e0", color: "#fff" }} id="collection_details" data-id="collection_details">Save <span className="tooltiptext-op"></span> </a>
                                                                    <p>{deliveryaddmsg}</p>

                                                                </div>
                                                                <div style={{ position: 'absolute', right: 0 }}> <label id="error_col_del" style={{ display: 'none' }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3" style={{ marginTop: "-6px" }}>
                                                                <select className="form-control" name="save_details_collection" onChange={(e) => getAddressdelivery(e.target.value)} id="details_collection">
                                                                    <option value>Select Save Address</option>

                                                                    {
                                                                        [...Array(deliverycount)].map((e, i) => <>
                                                                            {deliveryaddress && deliveryaddress[i] != '' ? (

                                                                                <option key={i} value={i}>{deliveryaddress[i]['name']}-{deliveryaddress[i]['address']}</option>
                                                                            ) : null
                                                                            }
                                                                        </>
                                                                        )
                                                                    }
                                                                </select>
                                                            </div>
                                                            <div className="col-md-2 adrresscheck"> <Link to="/my-account/address-book" style={{ padding: '10px', backgroundColor: '#3c50e0', color: '#fff', borderRadius: '4px', textDecoration: " none" }} className="addresslink">Check address book</Link>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : null
                                                }
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Name<span className="required">*</span></label>
                                                            <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.name.length < 1 ? 'error form-control' : 'form-control'} value={deliveryDetails.name} name="delivery_name" id="delivery_name" onChange={(e) => setdeliveryDetails({ ...deliveryDetails, name: e.target.value })} maxLength={50} placeholder="Name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Email<span className="required"></span></label>
                                                            <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.email.length < 1 ? ' form-control' : 'form-control'} value={deliveryDetails.email} name="delivery_email" id="delivery_email" placeholder="Email" onChange={(e) => setdeliveryDetails({ ...deliveryDetails, email: e.target.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Phone<span className="required">*</span></label>
                                                            <div className="input-group new-group">
                                                                {/* <div className="input-group-addon" style={{ paddingTop: "6%" }}>{countryphone[`${destination}`]}</div>
                                                                <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.phone.length < 1 ? 'error form-control' : 'form-control'} value={deliveryDetails.phone} name="delivery_phone" id="delivery_phone" placeholder="Phone" style={{ margin: 0 }} onChange={(e) => setdeliveryDetails({ ...deliveryDetails, phone: e.target.value })} /> */}
                                                                <PhoneInput
                                                                    international
                                                                    countryCallingCodeEditable={false}
                                                                    defaultCountry={countryCodeMap[countries[`${destination}`]]}
                                                                    value={deliveryDetails.phone}
                                                                    onChange={(newValue) => setdeliveryDetails({ ...deliveryDetails, phone: newValue })}
                                                                    style={{ "display": "flex", "backgroundColor": "#f7f7f7", "height": "2.9em" }}
                                                                    className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.phone.length < 1 ? 'error form-control' : 'form-control'}
                                                                />
                                                                <input type="hidden" name="delivery_phone_code" id="delivery_phone_code" defaultValue="<?php echo $delivery_phone_code ?>" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1">Address<span className="required">*</span></label>
                                                            <div className="input-group new-group">
                                                                <div className="input-group-addon" style={{ paddingTop: "6%", cursor: "pointer" }} onClick={() => setDeliveryMap(!deliveryMap)}>Map</div>
                                                                <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.address.length < 1 ? 'error form-control' : 'form-control'} value={deliveryDetails.address} name="delivery_address" id="delivery_address" placeholder="Address" onChange={(e) => checkSuggestionsdelivery(e.target.value)} onBlur={removesuggestdelivery} />
                                                            </div>
                                                            {showsuggestiondelivery == true ? (<>
                                                                <div className="suggestions">
                                                                    {
                                                                        suggestions.map((k, i) => <>
                                                                            {i > 0 ? (
                                                                                <p key={i} className="suggest" value={k} onClick={() => setSuggestaddressdelivery(k)} onBlur={removesuggestdelivery}>{k}</p>
                                                                            ) : null}
                                                                        </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </>
                                                            ) : null}

                                                            {
                                                                deliveryMap && <GoogleMap mapContainerStyle={mapContainerStyle} zoom={10} center={center2} onClick={handleMapDeliveryClick}>
                                                                    <Marker position={center2} />
                                                                </GoogleMap>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">City/Town<span className="required">*</span></label>
                                                                    {disable ? (
                                                                        <input type="text" disabled className="form-control" value={deliveryDetails.city} name="delivery_city" id="delivery_city" placeholder="City/Town" onChange={(e) => setdeliveryDetails({ ...deliveryDetails, city: e.target.value })} />
                                                                    ) : (
                                                                        <input type="text" className={nextpage == 0 ? 'form-control' : nextpage == 1 && deliveryDetails.city.length < 1 ? 'error form-control' : 'form-control'} value={deliveryDetails.city} name="delivery_city" id="delivery_city" placeholder="City/Town" onChange={(e) => setdeliveryDetails({ ...deliveryDetails, city: e.target.value })} />
                                                                    )}

                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Country<span className="required">*</span></label>
                                                                    <input type="text" className="form-control" name="delivery_country" id="delivery_country" defaultValue={countries[`${destination}`]} disabled />

                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="exampleInputEmail1">Zipcode</label>
                                                                    <input type="text" className="form-control" value={deliveryDetails.zip_code} name="delivery_zipcode" id="delivery_zipcode" placeholder="Zipcode" onChange={(e) => setdeliveryDetails({ ...deliveryDetails, zip_code: e.target.value })} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div></div>

                                    ) : null
                                    }
                                    <hr className="hr_border" style={{ margin: '20px 0' }} />
                                    <div className="btn-save rr-btn" style={{ textAlign: 'center' }}>

                                        <input type="hidden" defaultValue={1} name="parcel_stage" />
                                        <input type="hidden" name="promo_discount" defaultValue id="promo_discount" />
                                        <p className="error-message" style={{ color: "red" }}>{errormsg}</p>
                                        <p className="error-message" style={{ color: "red" }}>{insuranceerrormsg}</p>
                                        <p className="error-message" style={{ color: "red" }}>{emailerrormsg}</p>
                                        <p className="error-message" style={{ color: "red" }}>{emailerrormsg2}</p>
                                        {
                                            totalNumber === number + 1 && (
                                                <button
                                                    className="btn_same r_sub"
                                                    type="button"
                                                    onClick={() => {
                                                        setParcelDetailFirstOption(true);
                                                        setParcelDetailOption(!parcelDetailOption);
                                                    }}
                                                    name="parcel_step1"
                                                    id="parcel_step1"
                                                    style={{ marginTop: '10px' }}
                                                >
                                                    SUBMIT
                                                </button>
                                            )
                                        }
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
